import React from "react";
import { useNavigate } from "react-router-dom";

const ConsultationCard = ({ patient }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/dashboard/doctor-management/patient-details/${patient.patient_id}`);
  };

  const firstConsultation = patient.consultations?.[0];

  // Extract name from first consultation markdown
  let patientName = "Unknown";
  if (firstConsultation?.markdown) {
    const lines = firstConsultation.markdown.split("\n");
    const nameLine = lines.find((line) => line.includes("- Name:"));
    if (nameLine) {
      patientName = nameLine.replace("- Name:", "").trim();
    }
  }

  return (
    <div
      onClick={handleClick}
      className="bg-white dark:bg-[#0b1437] rounded-2xl border border-gray-200 dark:border-gray-700 p-6 hover:shadow-xl hover:-translate-y-1 transition-transform cursor-pointer flex flex-col justify-between h-full"
    >
      <div className="mb-4">
        <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
          {patientName}
        </h3>
        <p className="text-gray-500 dark:text-gray-400 text-sm mb-2">Patient ID: {patient.patient_id}</p>
        <div className="inline-block bg-indigo-100 text-indigo-800 dark:bg-indigo-800 dark:text-white px-3 py-1 rounded-full text-sm font-medium">
          {patient.consultations?.length || 0} Consultation{patient.consultations?.length > 1 ? "s" : ""}
        </div>
      </div>

      <div className="mt-auto">
        <p className="text-gray-400 dark:text-gray-300 text-sm">Click to view details</p>
      </div>
    </div>
  );
};

export default ConsultationCard;
